/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IssuerConvergenceCandidate,
  IssuerConvergenceCandidate$inboundSchema,
} from "./issuerconvergencecandidate.js";

/**
 * Result type for the platform-administrator convergence-candidate listing.
 */
export type ListIssuerConvergenceCandidatesResult = {
  items: Array<IssuerConvergenceCandidate>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListIssuerConvergenceCandidatesResult$inboundSchema: z.ZodMiniType<
  ListIssuerConvergenceCandidatesResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(IssuerConvergenceCandidate$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listIssuerConvergenceCandidatesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListIssuerConvergenceCandidatesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListIssuerConvergenceCandidatesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIssuerConvergenceCandidatesResult' from JSON`,
  );
}
